import {Injectable} from '@angular/core';
import {firstValueFrom, Observable} from 'rxjs';
import {ApiHelperService} from 'src/app/core/helpers/api-helper.service';
import {environment} from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class StaticPagesService {

    constructor(
        private api: ApiHelperService,
    ) {
    }

    submitVendorForm(body: any): Observable<any> {
        return this.api.create(environment.POST_VENDOR_APPLICATION, body);
    }

    submitCustomDataRequest(body: any): Observable<any> {
        return this.api.create(environment.POST_CUSTOM_DATA_REQUEST, body);
    }

    submitFeedback(body: any): Observable<any> {
        return this.api.create(environment.POST_FEEDBACK, body);
    }

    async formFileUpload(formData: any): Promise<any> {
        return await firstValueFrom(this.api.postFormData(environment.FORM_FILE_UPLOAD, formData));
    }

    async submitPartnerContact(body: any): Promise<any> {
        return await firstValueFrom(this.api.create(environment.PARTNER_CONTACT, body));
    }

    async submitResearchApply(body: any): Promise<any> {
        return await firstValueFrom(this.api.create(environment.POST_RESEARCH_APPLY, body));
    }

    async submitPartnerApply(body: any): Promise<any> {
        return await firstValueFrom(this.api.create(environment.POST_PARTNER_APPLY, body));
    }

    async submitCor3Apply(body: any): Promise<any> {
        return await firstValueFrom(this.api.create(environment.POST_COR3_APPLY, body));
    }

    async submitFacultyScholar(body: any): Promise<any> {
        return await firstValueFrom(this.api.create(environment.POST_FACULTY_SCHOLAR, body));
    }

    async submitPhdFellow(body: any): Promise<any> {
        return await firstValueFrom(this.api.create(environment.POST_PHD_FELLOW, body));
    }
}
